import { ISimpleLine } from './isimple-line';
import { CustomSimpleLine } from '../model/custom-simple-line';
import { SimpleLineOptions } from '../model/simple-line-options';

export class SimpleLine implements ISimpleLine {
	private readonly _priceLine: CustomSimpleLine;

	public constructor(priceLine: CustomSimpleLine) {
		this._priceLine = priceLine;
	}

	public applyOptions(options: Partial<SimpleLineOptions>): void {
		this._priceLine.applyOptions(options);
	}
	
	public options(): Readonly<SimpleLineOptions> {
		return this._priceLine.options();
	}

	public priceLine(): CustomSimpleLine {
		return this._priceLine;
	}
}
